import { create } from "zustand";

export type LearnerSyncPhase =
  | "local-only"
  | "not-connected"
  | "connecting"
  | "synced"
  | "pending"
  | "offline"
  | "auth-required"
  | "blocked"
  | "retry"
  | "error";

interface LearnerSyncStatusState {
  readonly phase: LearnerSyncPhase;
  readonly pendingEvents: number;
  readonly reasonCode: string | undefined;
  setStatus: (
    phase: LearnerSyncPhase,
    options?: { readonly pendingEvents?: number; readonly reasonCode?: string },
  ) => void;
}

export const useLearnerSyncStatus = create<LearnerSyncStatusState>((set) => ({
  phase: "local-only",
  pendingEvents: 0,
  reasonCode: undefined,
  setStatus: (phase, options = {}) =>
    set({
      phase,
      pendingEvents: options.pendingEvents ?? 0,
      ...(options.reasonCode ? { reasonCode: options.reasonCode } : { reasonCode: undefined }),
    }),
}));
